import { Pipe, PipeTransform } from '@angular/core';
import { PluralizePipe } from './pluralize.pipe';

@Pipe({ standalone: false, name: 'selectionsCount' })
export class SelectionsCountPipe implements PipeTransform {
  pluralizePipe = new PluralizePipe();

  transform(
    initial: any[],
    selected: any[],
    subject: string,
    adjective: string = 'selected',
    altSelectedComparator?: any[]
  ): string {
    let countText = '';

    if (selected && selected.length > 0) {
      countText =
        (((altSelectedComparator && altSelectedComparator.length) || selected.length) === initial.length
          ? 'All '
          : '') + selected.length.toString(10);
      return countText
        ? `${countText} ${subject}${this.pluralizePipe.transform(selected.length)} ${this.pluralizePipe.transform(
            selected.length,
            'are',
            'is'
          )} ${adjective}`
        : '';
    }

    return '';
  }
}
